/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduledPruneDto } from '../models/ScheduledPruneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantPruneControllerService {

    /**
     * @param name
     * @param port
     * @returns ScheduledPruneDto OK
     * @throws ApiError
     */
    public static getParticipantPruningSchedule(
        name: string,
        port: number = 5019,
    ): CancelablePromise<ScheduledPruneDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @param port
     * @returns any Created
     * @throws ApiError
     */
    public static createParticipantPruningSchedule(
        name: string,
        requestBody: ScheduledPruneDto,
        port: number = 5019,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param port
     * @returns void
     * @throws ApiError
     */
    public static deleteParticipantPruningSchedule(
        name: string,
        port: number = 5019,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/participants/{name}/prune',
            path: {
                'name': name,
            },
            query: {
                'port': port,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
